// Centralised TanStack Query keys. Mirrors mobile/src/config/query-keys.ts so
// the same query names land in the cache regardless of platform.

export const queryKeys = {
  sessionInit: ['session', 'init'] as const,
  profile: ['profile'] as const,
  profileCompletion: ['profile', 'completion'] as const,

  feed: {
    list: (category?: string, country?: string, subscribedOnly?: boolean) =>
      [
        'feed',
        'list',
        category ?? null,
        country ?? null,
        subscribedOnly ?? false,
      ] as const,
    search: (query: string) => ['feed', 'search', query] as const,
    article: (id: string) => ['feed', 'article', id] as const,
    translation: (articleId: string, language: string) =>
      ['feed', 'translation', articleId, language] as const,
    readStatus: ['feed', 'read-status'] as const,
    tagFeed: (tag: string) => ['feed', 'tag', tag] as const,
    channelFeed: (channelId: string) => ['feed', 'channel', channelId] as const,
  },

  channels: {
    all: ['channels', 'all'] as const,
    subscribed: ['channels', 'subscribed'] as const,
    detail: (id: string) => ['channels', 'detail', id] as const,
    search: (query: string) => ['channels', 'search', query] as const,
    popular: (country: string | null) => ['channels', 'popular', country] as const,
    explore: ['channels', 'explore'] as const,
  },

  saved: {
    all: ['saved'] as const,
    list: ['saved', 'list'] as const,
    articles: ['saved', 'articles'] as const,
  },

  alerts: {
    active: () => ['alerts', 'active'] as const,
    detail: (id: string) => ['alerts', 'detail', id] as const,
  },

  expat: {
    forYou: ['expat', 'for-you'] as const,
    all: (category?: string) => ['expat', 'all', category ?? null] as const,
  },

  guides: {
    forYou: (lang: string) => ['guides', 'for-you', lang] as const,
    byCountry: (country: string, lang: string) => ['guides', 'by-country', country, lang] as const,
    search: (query: string, lang: string) => ['guides', 'search', query, lang] as const,
    list: (category?: string) => ['guides', 'list', category ?? null] as const,
    detail: (id: number, lang: string) => ['guides', 'detail', id, lang] as const,
  },

  notifications: {
    unreadCount: () => ['notifications', 'unread-count'] as const,
    preferences: () => ['notifications', 'preferences'] as const,
  },

  topics: {
    list: ['topics', 'list'] as const,
  },

  topicSubscriptions: {
    all: ['topic-subscriptions'] as const,
    list: ['topic-subscriptions', 'list'] as const,
  },

  platformLanguages: {
    active: ['platform-languages', 'active'] as const,
    known: ['platform-languages', 'known'] as const,
  },
} as const;
